var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-base", {
    ref: "form",
    staticClass:
      "contact-form grid grid-cols-1 lg:grid-cols-2 lg:gap-y-[19px] lg:gap-x-[50px] h-full lg:h-auto",
    attrs: { "data-office-info": _vm.officeTitle.toLowerCase() },
    on: { submit: _vm.submit },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var loading = ref.loading
          var success = ref.success
          return [
            _c("form-input", {
              attrs: {
                name: "first_name",
                placeholder: "Voornaam",
                rules: "required"
              },
              model: {
                value: _vm.payload.first_name,
                callback: function($$v) {
                  _vm.$set(_vm.payload, "first_name", $$v)
                },
                expression: "payload.first_name"
              }
            }),
            _vm._v(" "),
            _c("form-input", {
              attrs: {
                name: "last_name",
                placeholder: "Achternaam",
                rules: "required"
              },
              model: {
                value: _vm.payload.last_name,
                callback: function($$v) {
                  _vm.$set(_vm.payload, "last_name", $$v)
                },
                expression: "payload.last_name"
              }
            }),
            _vm._v(" "),
            _c("form-input", {
              attrs: {
                name: "email",
                placeholder: "E-mailadres",
                type: "email",
                rules: "required|email"
              },
              model: {
                value: _vm.payload.email,
                callback: function($$v) {
                  _vm.$set(_vm.payload, "email", $$v)
                },
                expression: "payload.email"
              }
            }),
            _vm._v(" "),
            _c("form-phone", {
              attrs: {
                name: "phone",
                placeholder: "Telefoon",
                rules: "required|phone_number"
              },
              model: {
                value: _vm.payload.phone,
                callback: function($$v) {
                  _vm.$set(_vm.payload, "phone", $$v)
                },
                expression: "payload.phone"
              }
            }),
            _vm._v(" "),
            _c("form-textarea", {
              attrs: { name: "message", placeholder: "Bericht" },
              model: {
                value: _vm.payload.message,
                callback: function($$v) {
                  _vm.$set(_vm.payload, "message", $$v)
                },
                expression: "payload.message"
              }
            }),
            _vm._v(" "),
            _c("form-file", {
              staticClass: "min-h-[200px]",
              model: {
                value: _vm.payload.files,
                callback: function($$v) {
                  _vm.$set(_vm.payload, "files", $$v)
                },
                expression: "payload.files"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex col-span-1 lg:col-span-2" },
              [
                _c("form-error", {
                  attrs: { "error-response": _vm.errorResponse }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex col-span-1 lg:col-span-2 items-center  gap-32"
                  },
                  [
                    _c(
                      "form-submit",
                      {
                        staticClass:
                          "w-full mt-32 lg:mt-0 md:w-auto whitespace-nowrap",
                        attrs: {
                          disabled: invalid,
                          loading: loading,
                          success: success
                        }
                      },
                      [_vm._v("contacteer ons")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-bold" }, [
                      _vm._v(_vm._s(_vm.success_message))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }